import { types } from '../actions/types';

export const CommentReducer = (
  state = {
    get: null,
    create: null,
    update: null,
    deleteById: null,
  },
  action,
) => {
  switch (action.type) {
    case types.cmGetComments:
      return { ...state, get: action.payload };
    case types.cmCreateComment:
      return { ...state, create: action.payload };
    case types.cmUpdateComment:
      return { ...state, update: action.payload };
    case types.cmDeleteCommentById:
      return { ...state, deleteById: action.payload };
    default:
      return state;
  }
};
